<template>
  <div>
    <div class="sep"></div>
    <h2 class="align_left">
      <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
      {{ box.nom }}
    </h2>
    <div class="list_puce_stats_parcours">
      <div class="puce_stats_parcours">
        <p class="value_puce">{{ box.nb_attendu }} coureurs attendus</p>
      </div>
      <div class="puce_stats_parcours">
        <p class="value_puce">{{ box.nb_passe }} coureurs passés</p>
      </div>
      <div class="puce_stats_parcours">
        <p class="value_puce">{{ box.nb_restant }} coureurs restants</p>
      </div>
    </div>

    <b-table class="align_left" responsive :items="course_demaree" :fields="fields" :tbody-tr-class="rowClass" v-if="course_demaree.length > 0">
      <template #cell(nom)="data">
        {{ data.item.nom }}
      </template>
      <template #cell(infos)="data">
        {{ data.item.infos_course }}
      </template>
      <template #cell(coureur_attendu)="data">
        <span v-if="data.item.statistique">{{ data.item.statistique.nb_attendu }}</span
        ><span v-else>-</span>
      </template>
      <template #cell(coureur_passe)="data">
        <span v-if="data.item.statistique">{{ data.item.statistique.nb_passe }}</span
        ><span v-else>-</span>
      </template>
      <template #cell(coureur_restant)="data">
        <b v-if="data.item.statistique.nb_restant == 0">{{ data.item.statistique.nb_restant }}</b>
        <div v-else>
          <b>{{ data.item.statistique.nb_restant }}</b>
          <b-btn class="inline-btn" @click="data.toggleDetails"><span v-if="data.detailsShowing">Masquer</span><span v-else>Afficher</span></b-btn>
        </div>
      </template>
      <template #row-details="row">
        <b-card>
          <p>
            Coureurs restants au point: <b>{{ row.item.nom }}</b>
          </p>
          <p v-if="row.item.coureurs_attendus.length > 10">
            <i>
              <b-icon icon="exclamation-circle-fill" class="primary_color" aria-hidden="true"></b-icon>
              Il y a plus de 10 coureurs restants au point, la liste est tronquée
            </i>
          </p>
          <div v-if="row.item.coureurs_attendus.length > 10">
            <b-btn class="inline-btn" v-if="nb_attendu_to_display != 50" @click="nb_attendu_to_display = 50">En afficher plus</b-btn>
            <b-btn class="inline-btn" v-else @click="nb_attendu_to_display = 10">En afficher moins</b-btn>
          </div>
          <b-table :items="nb_attendu_to_display == 10 ? row.item.coureurs_attendus.slice(0, nb_attendu_to_display) : row.item.coureurs_attendus" :fields="['dossard', 'nom', 'prenom', 'fiche_coureur']" small responsive>
            <template #cell(nom)="data"> {{ data.item.nom }}</template>
            <template #cell(prenom)="data">
              {{ data.item.prenom }}
            </template>
            <template #cell(dossard)="data">
              {{ data.item.dossard }}
            </template>
            <template #cell(fiche_coureur)="data">
              <b-button class="inline-btn with_icon" @click="openFicheCoureur(data)"><b-icon icon="person" aria-hidden="true"></b-icon> Ouvrir sa fiche</b-button>
            </template>
          </b-table>
        </b-card>
      </template>
    </b-table>
    <div v-if="course_a_venir.length > 0">
      <div class="sep"></div>
      <p><b>Passages à venir sur ce point, en attente du départ de la course :</b></p>
      <div class="list_puce_stats_parcours">
        <div class="puce_stats_parcours" v-for="(course, index_course) in course_a_venir" :key="index_course">{{ course.nom }}</div>
      </div>
      <div class="sep"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["box", "name"],
  data() {
    return {
      nb_attendu_to_display: 10,
      fields: [
        { key: "nom", label: "Nom" },
        { key: "infos", label: "Infos de course" },
        { key: "coureur_attendu", label: "Coureurs attendus" },
        { key: "coureur_passe", label: "Coureurs passés" },
        { key: "coureur_restant", label: "Coureurs restants" },
      ],
    };
  },
  computed: {
    course_demaree() {
      let list = this.box.points;
      list = list.filter((item) => item.statistique);
      return list;
    },
    course_a_venir() {
      let list = this.box.points;
      list = list.filter((item) => !item.statistique);
      return list;
    },
  },
  methods: {
    openFicheCoureur(data) {
      var fiche_path = "fiche/" + data.item.id;
      this.$router.push({ path: fiche_path });
    },
    rowClass(item, type) {
      if (!item || !item.statistique || type !== "row") return;
      if (item.statistique.nb_restant == 0) return "clear_row";
      if (item.statistique.nb_restant > 0) return "missing_row";
    },
  },
};
</script>

<style lang="scss" scoped>
.statut_course {
  text-align: left;
  font-weight: bold;
}

.list_puce_stats_parcours {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
}
</style>